import moment from 'moment';
import { Page } from '../model/elements';
import { TaskPermissionActionFolderTarget } from '../model/entities';
import { syncApiAxios } from './CustomAxios';

class TaskPermissionActionFolderTargetApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        taskPermissionActionFolderId: number,
        searchText?: string,
    ): Promise<Page<TaskPermissionActionFolderTarget>> => {
        const response = await syncApiAxios.get<Page<TaskPermissionActionFolderTarget>>(
            '/task-permission-action-folder-targets',
            {
                params: { page, size, sortField, sortOrder, taskPermissionActionFolderId, searchText },
            },
        );
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((d) => {
            d.audit!.created = d.audit!.created && moment.utc(d.audit!.created).local();
            d.audit!.updated = d.audit!.updated && moment.utc(d.audit!.updated).local();
        });

        return response.data;
    };
}

const taskPermissionActionFolderTargetApi: TaskPermissionActionFolderTargetApi =
    new TaskPermissionActionFolderTargetApi();
export default taskPermissionActionFolderTargetApi;
